import React, { memo } from "react";
import Switch from "react-switch";
import { cn } from "../../services/common/className";
import "./xgs-toggle.scss";

export interface XGSToggleProps {
  label?: string;
  checked: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  width?: number;
  height?: number;
  handleDiameter?: number;
}

const XGSToggle: React.FC<XGSToggleProps> = memo(({
  checked,
  disabled,
  label,
  onChange,
  width,
  height,
  handleDiameter
}) => {
  return (
    <div className={cn("xgs-toggle")({checked})}>
      <Switch
        onChange={onChange}
        checked={checked}
        disabled={disabled}
        width={width ?? 32}
        height={height ?? 20}
        offColor="#9CA5B0"
        onColor="#2F80ED"
        handleDiameter={handleDiameter ?? 16}
        uncheckedIcon={<></>}
        checkedIcon={<></>}
      />
      <span
        className={cn("xgs-toggle__label")({disabled}) + " no-select"}
        onClick={() => !disabled && onChange(!checked)}
      >
        {label}
      </span>
    </div>
  );
});

export default XGSToggle;
